import moment from 'moment';
import React, { useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useDispatch, useSelector } from "react-redux";

import { stepperInfoActions } from "../../store/slices/stepperInfoSlice";
import { getKyivNow } from "../../utils/kyivTime";
import './AppCalendar.scss';

const AppCalendar = () => {
    const dispatch = useDispatch();
    const {selectedDate, selectedTime, request_datetime} = useSelector(state => state.stepperInfo);

    const handleChangeRequestTime = (date) => {
        dispatch(stepperInfoActions.setSelectedDate(date.toISOString()));

        const combinedDateTime = moment(date).set({
            hour: selectedTime?.split(':')[0],
            minute: selectedTime?.split(':')[1],
        });

        dispatch(stepperInfoActions.setRequestDateTime(combinedDateTime.toISOString()));
    }

    return (
        <>
            <div className={'calendarDesktop'}>
                <Calendar
                    minDate={getKyivNow()}
                    value={selectedDate}
                    onChange={handleChangeRequestTime}
                    showDoubleView={true}
                    locale={"uk-UA"}
                />
            </div>

            <div className={'calendarMobile'}>
                <Calendar
                    minDate={getKyivNow()}
                    value={request_datetime}
                    onChange={handleChangeRequestTime}
                    locale={"uk-UA"}
                />
            </div>
        </>
    );
};

export default AppCalendar;
